import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectResult = createSelector(
  [(store: RootState) => store.fichaMiDt.result],
  (data) => data
);
